import api_url from "../../libary/axios-home";

export const getAllCities = async () => {
    const {data} = await api_url.get('/cities');
    return data;
}